<template>
  <header class="row navigation-bar align-items-center" v-if="isNavigationBar">
    <div class="col-lg-8 col-md-8 col-sm-8 col-6">
      <a :href="aiLink" class="item">
        <img src="/static/images/ct_ai_logo.png" alt="app logo">
      </a>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-4 col-6 text-right">
      <img v-if="!isParentUser && !isTeacherUser" :src="`/static/images/${isActiveLicenceUser}`" class="licence-icon" @click="userLicence()"/>
      <img v-if="isPrime" :src="`/static/images/ic-prime-24.svg`" class="prime-icon" />
      <div class="navigation-dropdown" style="display: inline-block;">
        <b-dropdown variant="link" no-caret :right="true">
          <template slot="button-content">
            <img :src="userProfileImage" class="user-profile" alt="profile" />
          </template>
          <b-dropdown-item @click="userBookmarkUrl()" v-if="!isParentUser && !isTeacherUser">
            {{ $t('common.bookmark') }}
          </b-dropdown-item>
          <b-dropdown-item @click="userLanguageUrl()">
            {{ $t('common.update_language') }}
          </b-dropdown-item>          
          <!-- <b-dropdown-item @click="userCourseUrl()">
            {{ $t('common.subscription_course') }}
          </b-dropdown-item> -->
          <b-dropdown-item @click="userProfileUrl()">
            {{ $t('common.go_to_ct') }}            
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>

<script>
  import { mapGetters } from 'vuex';

  import { CLASSTING_URL, CT_STORE_URL, CLASSTING_AI_INTRO_WEB } from '@/config';

  export default {
    name: 'navigation-bar',

    data() {
      return {
        ctStoreUrl: CT_STORE_URL,
      };
    },

    computed: {
      ...mapGetters([
        'currentUser',
        'currentUserId',
        'isParentUser',
        'isPrime',
        'isUserLicence',
        'isTeacherUser',
      ]),

      isNavigationBar() {
        if (this.$mobile.isClasstingAndroid()) {
          return false;
        }
        return true;
      },

      userProfileImage() {
        return this.currentUser && this.currentUser.profile_image;
      },

      isActiveLicenceUser() {
        if (this.isUserLicence) {
          return 'ic-license-active.svg';
        }

        return 'ic-course-inactive.svg';
      },

      aiLink() {
        return `${CLASSTING_AI_INTRO_WEB}/home`;
      },
    },

    methods: {
      userBookmarkUrl() {
        this.$router.push({ name: 'bookmark' });
      },

      userCourseUrl() {
        this.$router.push({ name: 'subscription-course' });
      },

      userProfileUrl() {
        if (this.currentUserId) {
          return window.open(`${CLASSTING_URL}/news`);
        }
        return '/';
      },

      userLanguageUrl() {
        return window.open(`${CLASSTING_URL}/settings/personal_info`);
      },

      userLicence() {
        this.$router.push({ name: 'user-licence' });
      },

    },

    beforeMount() {
      if (this.$mobile.isClasstingAndroid()) {
        this.$moblie.callActionbar(true);
      }
    },
  };
</script>

<style lang="scss" scoped>
  .navigation-bar {
    background-color: #ffffff;
    padding: 14px;
    width: 100%;
    margin: 0;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);

    .item {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.87);
      padding: 0px 14px 0px 14px;
      text-decoration: none;

      &.active {
        color: rgba(0, 200, 150, 0.87);
        font-weight: bold;
      }
    }

    .prime-icon {
      display: inline-block;
      margin-right: 2px; 
    }

    .licence-icon {
      display: inline-block; 
      margin-right: 12px;
      cursor: pointer;
    }

    .user-profile {
      width: 36px;
      height: 36px;
      border-radius: 36px;
      border: solid 1px #d9d9d9;
      object-fit: cover;
    }
  }
</style>


// WEBPACK FOOTER //
// NavigationBar.vue?f2b154e4